import { useMutation } from '@tanstack/react-query';

import { haggleApiService } from '@/services/haggle.service';

export const useInviteUser = () => {
	return useMutation({
		mutationFn: async ({
			invitedEmail,
			adminEmail,
			name,
		}: {
			invitedEmail: string;
			adminEmail: string;
			name: string;
		}) => {
			return await haggleApiService.inviteMerchant({
				invitedEmail,
				adminEmail,
				name,
			});
		},
	});
};
